/*
*
* File JS import generico POST MODULES
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

// Cards
import card20 from 'components/cards/card-20';
import card25 from 'components/cards/card-25';
import card40 from 'components/cards/card-40';
import card40Third from 'components/cards/card-40-third';
import card50Third from 'components/cards/card-50-third';
import card80 from 'components/cards/card-80';

// Blocchi
import featured1 from 'components/featured-1/featured-1';
import featured1Big from 'components/featured-1-big/featured-1-big';
import featured1BigImage from 'components/featured-1-big-image/featured-1-big-image';
import featuredStreaming from 'components/featured-streaming/featured-streaming';
import blockPost1Adv180x150 from 'components/post-1-adv-180x150/post-1-adv-180x150';
import blockPost3Adv300x250 from 'components/post-3-adv-300x250/post-3-adv-300x250';
import blockPost1_3Adv180x150 from 'components/post-1+3-adv-180x150/post-1+3-adv-180x150';
import blockPost2_2Adv180x150 from 'components/post-2+2-adv-180x150/post-2+2-adv-180x150';
import blockPost4Adv180x150 from 'components/post-4-adv-180x150/post-4-adv-180x150';
import blockPost5Adv300x250 from 'components/post-5-adv-300x250/post-5-adv-300x250';
import blockPost5Adv160x600 from 'components/post-5-adv-160x600/post-5-adv-160x600';
import rowRubrica from 'components/row-rubrica/row-rubrica';
import blockPost6 from 'components/post-6/post-6';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './post-modules.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const postModules = () => {
    rowRubrica();
}

export default postModules;

//--------------------------------------------------------------------//